interface LinkMapping {
  keywords: string[];
  url: string;
  title: string;
}

class ContentLinker {
  private linkMappings: LinkMapping[] = [
    {
      keywords: ['aging in place', 'age in place', 'staying at home', 'living at home', 'thrive at home'],
      url: '/older-adults',
      title: 'SeniorThrive for Older Adults'
    },
    {
      keywords: ['family caregiver', 'family caregiving', 'caring for parents', 'helping parents', 'family members'],
      url: '/thrivefamily',
      title: 'SeniorThrive for Family Members'
    },
    {
      keywords: ['professional caregiver', 'care professional', 'home care', 'caregiver support', 'care coordination'],
      url: '/caregivers',
      title: 'SeniorThrive for Caregivers'
    },
    {
      keywords: ['fall prevention', 'home safety', 'safety check', 'fall risk', 'home hazard', 'safety assessment'],
      url: '/older-adults',
      title: 'Smart Home Safety'
    },
    {
      keywords: ['ThriveScore', 'wellness score', 'health score'],
      url: '/older-adults',
      title: 'ThriveScore Wellness Metric'
    },
    {
      keywords: ['wellness assessment', 'health check', 'wellness questionnaire'],
      url: '/older-adults',
      title: 'Wellness Assessments'
    },
    {
      keywords: ['care circle', 'ThriveCircle', 'support network'],
      url: '/thrivefamily',
      title: 'Build Your Care Circle'
    },
    {
      keywords: ['caregiver burnout', 'caregiver stress', 'caregiver well-being'],
      url: '/thrivefamily',
      title: 'Caregiver Support Resources'
    },
    {
      keywords: ['pricing', 'cost', 'subscription', 'plan', 'free trial'],
      url: '/pricing',
      title: 'SeniorThrive Pricing Plans'
    },
    {
      keywords: ['contact us', 'get started', 'learn more', 'support'],
      url: '/contact',
      title: 'Contact SeniorThrive'
    },
    // Blog cross-links, connect orphaned posts to the content network
    {
      keywords: ['grab bars', 'bathroom safety', 'bathroom modifications'],
      url: '/blog/the-importance-of-secure-easy-to-use-bathroom-grab-bars-for-safe-independent-seniors',
      title: 'Bathroom Grab Bars for Seniors'
    },
    {
      keywords: ['outdoor lighting', 'exterior lighting', 'porch lights'],
      url: '/blog/enhancing-senior-safety-with-outdoor-lighting-solutions',
      title: 'Outdoor Lighting for Senior Safety'
    },
    {
      keywords: ['activities of daily living', 'ADLs'],
      url: '/blog/empowering-seniors-understanding-activities-of-daily-living',
      title: 'Understanding Activities of Daily Living'
    },
    {
      keywords: ['empty nester', 'empty nest'],
      url: '/blog/empty-nester-what-you-need-to-know-to-thrive',
      title: 'Thriving as an Empty Nester'
    },
    {
      keywords: ['decision-making capacity', 'diminishing decisions', 'questionable choices'],
      url: '/blog/navigating-the-difficult-waters-of-diminishing-decision-making-in-elderly-parents-a-compassionate-guide',
      title: 'When Parents Make Poor Decisions'
    },
    {
      keywords: ['staying hydrated', 'dehydration in seniors', 'water intake'],
      url: '/blog/hydration-for-seniors',
      title: 'Hydration Tips for Seniors'
    },
    {
      keywords: ['senior driving', 'driving assessment', 'driving safety for seniors'],
      url: '/blog/senior-driving-safety-independence',
      title: 'Senior Driving Safety'
    },
    {
      keywords: ['sleep quality for seniors', 'pillow for seniors', 'better sleep for older adults'],
      url: '/blog/discover-the-best-pillow-for-older-adults-comfort-quality',
      title: 'Best Pillows for Older Adults'
    },
    {
      keywords: ['frustrating elderly parents', 'parent refuses help', 'resistant to help'],
      url: '/blog/how-to-deal-with-frustrating-elderly-parents-empathy-strategies-and-solutions',
      title: 'Dealing with Frustrating Elderly Parents'
    },
    {
      keywords: ['holiday safety for seniors', 'holiday decorations safety'],
      url: '/blog/7-mistakes-you-re-making-with-holiday-safety-for-seniors-and-how-to-fix-them',
      title: 'Holiday Safety Tips for Seniors'
    },
    // pSEO glossary cross-links, help Google discover /learn/ pages
    {
      keywords: ['sandwich generation'],
      url: '/learn/sandwich-generation',
      title: 'What Is the Sandwich Generation?'
    },
    {
      keywords: ['burnout from caregiving', 'caregiver exhaustion'],
      url: '/learn/caregiver-burnout',
      title: 'What Is Caregiver Burnout?'
    },
    {
      keywords: ['fall risk assessment', 'fall risk'],
      url: '/learn/fall-risk-assessment',
      title: 'What Is a Fall Risk Assessment?'
    }
  ];

  processContent(htmlContent: string): string {
    let processedContent = htmlContent;

    this.linkMappings.forEach(mapping => {
      mapping.keywords.forEach(keyword => {
        // Create case-insensitive regex that doesn't match already linked content
        const regex = new RegExp(
          `(?<!<a[^>]*>.*?)\\b(${this.escapeRegex(keyword)})\\b(?![^<]*</a>)`,
          'gi'
        );
        
        processedContent = processedContent.replace(regex, (match) => {
          return `<a href="${mapping.url}" class="text-primary hover:underline font-medium" title="${mapping.title}">${match}</a>`;
        });
      });
    });

    return processedContent;
  }

  private escapeRegex(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Extract keywords from content for related posts matching
  extractKeywords(content: string): string[] {
    const text = this.stripHtml(content).toLowerCase();
    const keywords: string[] = [];

    this.linkMappings.forEach(mapping => {
      mapping.keywords.forEach(keyword => {
        if (text.includes(keyword.toLowerCase())) {
          keywords.push(keyword);
        }
      });
    });

    return keywords;
  }

  private stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}

export const contentLinker = new ContentLinker();